import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.string.trim-start.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Block } from '../../abstract/Block.js';
export class Icon extends Block {
  constructor() {
    super(...arguments);
    _defineProperty(this, "init$", _objectSpread(_objectSpread({}, this.init$), {}, {
      name: '',
      path: '',
      size: '24',
      viewBox: ''
    }));
  }
  initCallback() {
    super.initCallback();
    this.sub('name', val => {
      if (!val) {
        return;
      }
      let path = this.getCssData("--icon-".concat(val));
      if (path) {
        this.$.path = path;
      }
    });
    this.sub('path', path => {
      if (!path) {
        return;
      }
      let isRaw = path.trimStart().startsWith('<');
      if (isRaw) {
        this.setAttribute('raw', '');
        this.ref.svg.innerHTML = path;
      } else {
        this.removeAttribute('raw');
        this.ref.svg.innerHTML = "<path fill-rule=\"evenodd\" d=\"".concat(path, "\"></path>");
      }
    });
    this.sub('size', size => {
      this.$.viewBox = "0 0 ".concat(size, " ").concat(size);
    });
  }
}
Icon.template = /* HTML */"\n  <svg ref=\"svg\" xmlns=\"http://www.w3.org/2000/svg\" set=\"@viewBox: viewBox; @height: size; @width: size\"></svg>\n";
Icon.bindAttributes({
  name: 'name',
  size: 'size'
});